import React, { useState } from 'react'
import { Checkbox, Drawer, Dropdown, Menu } from 'antd'

import { usePet, useToggle, notifOps } from '../../modules'

const NewInsurance = ({ toggle, visible, onPerform }) => {
    const [name, setName] = useState()
    const [address, setAddress] = useState()
    const [phone, setPhone] = useState()
    const [email, setEmail] = useState()
    const [contactPerson, setContactPerson] = useState()
    const [contactPersonPhone, setContactPersonPhone] = useState()
    const [isSha, setIsSha] = useState(false)

    const close = () => {
        toggle()
    }

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'address':
                setAddress(e.target.value)
                break

            case 'phone':
                setPhone(e.target.value)
                break

            case 'email':
                setEmail(e.target.value)
                break

            case 'contactPerson':
                setContactPerson(e.target.value)
                break

            case 'contactPersonPhone':
                setContactPersonPhone(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Insurance has been added', ops('success'))
        
        setTimeout(close, 300)
    }

    const [{ loading }, execute] = usePet('newInsuranceCompany', {
        name,
        address,
        phone,
        email,
        contactPerson,
        contactPersonPhone,
        isSha
    }, { notify: true, callback: onComplete, manual: true })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={execute} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create Company</button>
                </div>
            }
            width={600}>
            <p className="font-extrabold text-3xl mb-0">New Insurance Company</p>
            <div className="divide-y divide-light-gray-400">
                <div>
                    <div>
                        <p className="font-bold my-3">Company Details</p>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Company Name
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-name" 
                                    type="text" 
                                    value={ name }
                                    name="name"
                                    placeholder="Hisani Insurance" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Address <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-address" 
                                    type="text" 
                                    value={ address }
                                    name="address"
                                    placeholder="Centenary House, Westlands" />
                            </div>
                        </div>
                        <p className="font-bold my-3">Contact Information</p>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Phone
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-phone" 
                                    type="text" 
                                    value={ phone }
                                    name="phone"
                                    placeholder="07XXXXXXXX" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Email <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-email" 
                                    type="text" 
                                    value={ email }
                                    name="email"
                                    placeholder="company@domain.com" />
                            </div>
                        </div>
                        <p className="font-bold my-3">Contact Person</p>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Contact Person
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-contactPerson" 
                                    type="text" 
                                    value={ contactPerson }
                                    name="contactPerson"
                                    placeholder="Evans Kimani" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Contact Person Phone
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-contact-phone" 
                                    type="text" 
                                    value={ contactPersonPhone }
                                    name="contactPersonPhone"
                                    placeholder="07XXXXXXXX" />
                            </div>
                        </div>
                        <div className="mt-6 px-3">
                            <Checkbox checked={ isSha } onChange={ e => setIsSha(e.target.checked) }>
                                SHA-linked insurer
                            </Checkbox>
                            <p className="text-xs text-gray-500 mt-2 mb-0">
                                Enable this for insurers that should trigger SHA eligibility, consent, and claim workflows.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Drawer>
    )
}

export default NewInsurance
